import moment from "moment";

import template from "./pIncomeImport.html";

export function pIncomeImportDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pIncomeImportController,
    controllerAs: 'pIncomeImport',
    bindToController: true
  };

  return directive;
}

class pIncomeImportController {
  constructor(Auth, Controlling, DownloadFile, Stats, $interval, $scope, Notes, bModal, Sort) {
    'ngInject';
    this.DownloadFile = DownloadFile;
    this.Auth = Auth;
    this.Controlling = Controlling;
    this.Stats = Stats;
    this.Notes = Notes;
    this.bModal = bModal;
    this.Sort = Sort;
    this.$interval = $interval;
    this.$scope = $scope;
    this.anyAmount = null;
    this.excludeClientsWithNoTimeReported = true;

    this.modalConfig = {
      text: "CASEMAN.INCOME_OVERWRITE",
      cancelText: "CANCEL",
      acceptText: "Continue"
    };

    this.allSitesSelected = true;
    this.allServiceLinesSelected = true;
    this.allTeamsSelected = true;

    this.incomeSumAllClients = 0;
    this.incomeSumTimeClients = 0;
    this.incomeSumNoTimeClients = 0;
    this.canImportFromCaseman = false;
    this.numberOfUnmatchedRecords = null;

    this.month = (moment().month()+1).toString();
    this.year = moment().year().toString();
    if (this.month.length == 1) {
      this.month = "0"+this.month;
    }
    this.state = "loading";
    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        if(!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then( newUserInfo => {
            this.user = newUserInfo;
            this.canImportFromCaseman = !!this.user.preferences.featureFlags.find(f => f == "CASEmanIncomeImport");
          });
        } else {
          this.canImportFromCaseman = !!this.user.preferences.featureFlags.find(f => f == "CASEmanIncomeImport");
        }

        this.Stats.getSubordinateTeamsWithSites().then(
          (success) => {
            this.state = "loaded";

            // teams
            this.teams = success.data
              .filter(team => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : team.team.name != "Team Iterators")
              .map((teamObj) => ({...teamObj.team, sites: teamObj.sites.flatMap(s => s.id), selected: true}));
            const teamsActual = this.teams.filter(team => !team.archivedAt && team.sites.length != 0).sort(this.Sort.abcBy("name"));
            const teamsArchived = this.teams.filter(team => team.archivedAt || team.sites.length == 0).sort(this.Sort.abcBy("name"));
            this.teams = teamsActual.concat(teamsArchived);

            this.teamsDisplay = angular.fromJson(angular.toJson(this.teams));

            // sites
            this.sites = success.data
              .filter(team => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : team.team.name != "Team Iterators")
              .flatMap((team) => team.sites)
              .filter((site, i, self) => i === self.findIndex((t) => (t.id === site.id)))
              .filter(site => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : site.name != "Iterators HQ")
              .sort(this.compare);

            this.sitesDisplay = angular.fromJson(angular.toJson(this.sites));
            this.sitesDisplay.forEach(s => s.selected = true);

            // serviceLines
            this.serviceLines = success.data
              .filter(team => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : team.team.name != "Team Iterators")
              .map((team) => team.team.serviceLine)
              .filter((t, i, a) => a.indexOf(t) === i);

            this.serviceLinesDisplay = this.serviceLines.map(s => {
              return ({
                name: s,
                selected: true
              });
            });

            this.resetData();
          },
          (error) => {
            this.state = "error";
            this.error = error;
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});

      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  resetData() {
    this.allTeamsClients = undefined;
    this.withTimeTeamsClients = undefined;
    this.withIncomeNoTimeTeamsClients = undefined;
    this.selectedTeams = [];

    this.teamsDisplay = this.teams.filter(t => {
      if ((this.sitesDisplay.find(s => s.selected == true) ? (t.sites.find(s => this.sitesDisplay.find(site => site.selected && site.id == s)) || t.sites.length == 0) : true) &&
        (this.serviceLinesDisplay.find(s => s.selected == true) ? this.serviceLinesDisplay.find(s => s.selected && s.name == t.serviceLine) : this.serviceLinesDisplay.find(s => s.name == t.serviceLine))) {
        return t;
      } else {
        return null;
      }
    });

    if (this.allSitesSelected && this.sitesDisplay.find(c => c.selected != true)) {
      this.allSitesSelected = false;
    }
    if (!this.allSitesSelected && this.sitesDisplay.every(c => c.selected == true)) {
      this.allSitesSelected = true;
    }

    if (this.allServiceLinesSelected && this.serviceLinesDisplay.find(s => s.selected != true)) {
      this.allServiceLinesSelected = false;
    }
    if (!this.allServiceLinesSelected && this.serviceLinesDisplay.every(s => s.selected == true)) {
      this.allServiceLinesSelected = true;
    }

    if (this.allTeamsSelected && this.teamsDisplay.find(t => t.selected != true)) {
      this.allTeamsSelected = false;
    }
    if (!this.allTeamsSelected && this.teamsDisplay.every(t => t.selected == true)) {
      this.allTeamsSelected = true;
    }
    if (this.isAnySiteOrServiceLineSelected() === false) {
      this.allTeamsSelected = false;
      this.selectAllTeams();
    }
    this.selectedTeams = this.teamsDisplay.filter(({selected}) => selected);
    this.ids = this.selectedTeams.map(({id}) => id);
  }

  filterTeams() {
    if (this.isAnySiteOrServiceLineSelected() === false) {
      this.allTeamsSelected = false;
      this.selectAllTeams();
    }
  }

  selectAllSites() {
    this.sitesDisplay.forEach(site => {
      if (this.allSitesSelected) {
        site.selected = true;
      } else {
        site.selected = false;
      }
    });
    this.filterTeams();
    this.resetData();
  }

  isAnySiteOrServiceLineSelected() {
    const isAnySiteSelected = this.sitesDisplay.find(site => site.selected);
    const isAnyServiceLineSelected = this.serviceLinesDisplay.find(line => line.selected);
    return Boolean(isAnySiteSelected || isAnyServiceLineSelected);
  }

  selectAllServiceLines() {
    this.serviceLinesDisplay.forEach(s => {
      if (this.allServiceLinesSelected) {
        s.selected = true;
      } else {
        s.selected = false;
      }
    });
    this.filterTeams();
    this.resetData();
  }

  selectAllTeams() {
    this.teamsDisplay.forEach(c => {
      if (this.allTeamsSelected) {
        c.selected = true;
      } else {
        c.selected = false;
      }
    });
  }

  compare(a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  }

  selectTeam() {
    this.state = "loading";
    this.allTeamsClients = undefined;
    this.withTimeTeamsClients = undefined;
    this.withIncomeNoTimeTeamsClients = undefined;
    this.error = undefined;
    this.numberOfUnmatchedRecords = null;

    this.Controlling.getIncomeJson(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then(
      (incomeJsonSuccess) => {
        this.Controlling.getIncomeMappers(this.ids, this.year, this.month).then(
          (incomeMappersSuccess) => {
            this.handleIncomeJson(incomeJsonSuccess.data, incomeMappersSuccess.data);
            this.state = 'loaded';
          },
          (error) => {
            if (error.status !== 500) {
              this.state = "error";
              this.error = error;
            } else {
              this.handleIncomeJson(incomeJsonSuccess.data.dto, null);
              this.state = 'loaded';
            }
          }
        );
      },
      (error) => {
        this.state = "error";
        this.error = error;
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  handleIncomeJson(incomeJson, incomeMappers) {
    const clientMappers = incomeMappers && incomeMappers.clientMappers;
    const clientProjectMappers = incomeMappers && incomeMappers.clientProjectMappers;
    const teamMappers = incomeMappers && incomeMappers.teamMappers;

    this.hasIncomeMappers = incomeMappers ? true : false;
    const income = incomeJson.map(inc => {
      let casemanClient;
      let casemanTeam;

      if (clientMappers)
        casemanClient = clientMappers.find(client => client.clientId === inc.clientId);
      else if (clientProjectMappers)
        casemanClient = clientProjectMappers.find(client => client.clientId === inc.clientId);

      if (teamMappers)
        casemanTeam = teamMappers.find(team => team.teamId === inc.teamId);

      inc.casemanClientOrProjectName = casemanClient && (casemanClient.casemanClientName ? casemanClient.casemanClientName : casemanClient.casemanProjectName);
      inc.casemanTeamName = casemanTeam && casemanTeam.casemanTeamName;

      return inc;
    });

    this.allTeamsClients = income.map(el => ({...el, noTime: el.duration == 'PT0S' && el.amount && el.amount !== 0}));
    this.withTimeTeamsClients = this.allTeamsClients.filter(el => el.duration != 'PT0S');
    this.withIncomeNoTimeTeamsClients = this.allTeamsClients.filter(el => el.duration == 'PT0S' && el.amount && el.amount !== 0);

    this.anyAmount = this.excludeClientsWithNoTimeReported ? this.withTimeTeamsClients.find(e => e.amount) : this.allTeamsClients.find(e => e.amount);
    this.incomeSumAllClients = this.calculateSumForClients(this.allTeamsClients);
    this.incomeSumTimeClients = this.calculateSumForClients(this.withTimeTeamsClients);
    this.incomeSumNoTimeClients = this.calculateSumForClients(this.withIncomeNoTimeTeamsClients);
    this.totalIncome = this.incomeSumTimeClients + this.incomeSumNoTimeClients;
  }

  calculateSumForClients(clients) {
    return Math.round(clients.reduce((acc, curr) => acc + (curr.amount || 0), 0) * 100) / 100;
  }

  downloadTemplate() {
    this.state = "loading";
    this.error = undefined;
    this.Controlling.getIncomeExcel(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then((success) => {
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `income_report_${this.year}_${this.month}.xlsx`
        );
      this.state = "loaded";
    }, (error) => {
      this.state = "error";
      this.error = error;
      this.Notes.postNote({type: "error", error: error});
    });
  }

  fileChosen() {
    this.tempFile = undefined;
    this.loading = true;
    this.error = undefined;
    this.validFile = this.incomeExcelFile[0];
  }

  uploadIncomeExcel() {
    this.state = "loading";
    this.error = undefined;
    this.validFile = this.incomeExcelFile[0];
    this.Controlling.sendIncomeExcel(this.validFile, this.ids, this.year, this.month).then(() => {
      this.state = "loaded";
      this.selectTeam();
      this.validFile = null;
    }, (error) => {
      this.error = error;
      this.state = "loaded";
      this.Notes.postNote({type: "error", error: error});
    });
  }

  fetchCasemanIncome() {
    if (this.anyAmount) {
      this.bModal.show(this.modalConfig).then(() => this.doFetchCasemanIncome(), () => null);
    } else {
      this.doFetchCasemanIncome();
    }
  }

  fetchCasemanIncomeReport() {
    this.state = "loading";
    this.error = undefined;
    this.Controlling.fetchCasemanIncomeReport(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then((success) => {
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `sync_report_${this.year}_${this.month}.xlsx`
        );
      this.state = "loaded";
    }, () => {
      this.state = "loaded";
      this.Notes.postNote({type: "error", message: "Could not fetch income report, CASEman is down, please try again later"});
    });
  }

  doFetchCasemanIncome() {
    this.state = "loading";
    this.error = undefined;
    this.Controlling.fetchCasemanIncome(this.ids, this.year, this.month, this.excludeClientsWithNoTimeReported).then(({ data }) => {
      this.state = "loaded";
      this.selectTeam();
      this.numberOfUnmatchedRecords = data.numberOfUnmatched;
    }, (error) => {
      this.error = error;
      this.state = "loaded";
      this.Notes.postNote({type: "error", error: error});
    });
  }

}
